import { FEATURE_FLAGS } from '@app/app-constants'
import GlossaryPage from '@app/components/Pages/Guide/GlossaryPage'
import { GuideContentPage } from '@app/components/Pages/Guide/GuideContentPage'
import { GuideGetStartedPage } from '@app/modules/GuideV2/pages/get-started.page'
import SubTopicTemplatePage from '@app/modules/GuideV2/pages/subTopicTemplate.page'
import TopicLandingPage from '@app/modules/GuideV2/pages/guideTopicLanding.page'
import GuideLayout from '@app/modules/GuideV2/layout/guide.layout'
import { FeatureFlagGate } from '@app/FeatureFlag/FeatureFlagGate'
import { UnauthorizedPage } from '@app/routes/UnauthorisedPage/UnauthorizedPage'
import { Navigate, Route } from 'react-router-dom'

export default function GuideRoutes() {
  return (
    <Route
      path="guide"
      element={
        <FeatureFlagGate
          flag={FEATURE_FLAGS.GUIDE_PAGE}
          fallback={<UnauthorizedPage feature={FEATURE_FLAGS.GUIDE_PAGE} />}
        >
          <GuideLayout />
        </FeatureFlagGate>
      }
    >
      <Route index element={<Navigate to="get-started" replace />} />
      <Route path="get-started" element={<GuideGetStartedPage />} />
      <Route path="glossary" element={<GlossaryPage />} />
      <Route path=":mainTopic" element={<TopicLandingPage />} />
      <Route path=":mainTopic/:subTopic" element={<SubTopicTemplatePage />} />
      <Route path=":mainTopic/:subTopic/:articleSlug" element={<GuideContentPage />} />
    </Route>
  )
}
